import { render, staticRenderFns } from "./OccupationDetail.vue?vue&type=template&id=49304133&scoped=true&"
import script from "./OccupationDetail.vue?vue&type=script&lang=js&"
export * from "./OccupationDetail.vue?vue&type=script&lang=js&"
import style0 from "./OccupationDetail.vue?vue&type=style&index=0&id=49304133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49304133",
  null
  
)

export default component.exports